import { createReducer } from "utils/context";
import { PROPSOCH_ACTIONS } from "./actions";

export const initialState = {
  // global identifier for auth
  roles: null,
};

export const authReducer = createReducer({
  [PROPSOCH_ACTIONS.roles]: (state, { payload }) => ({
    ...state,
    roles: payload,
  }),
  [PROPSOCH_ACTIONS.users]: (state, { payload }) => ({
    ...state,
    users: payload,
  }),
  [PROPSOCH_ACTIONS.locations]: (state, { payload }) => ({
    ...state,
    locations: payload,
  }),
  [PROPSOCH_ACTIONS.userRole]: (state, { payload }) => ({
    ...state,
    userRole: payload,
  }),
});
